{
  "label": "Discussion Questions",
  "close": "Close",
  "empty": "There aren't any discussion questions for this message."
}
